import styled from "styled-components";

export const ContainerMenu = styled.div`
  display: none;

  @media (max-width: 1279px) {
    display: inline-block;
    position: fixed;
    z-index: 20000;
    background: linear-gradient(360deg, #001019 18.65%, #014e7a 76.55%);
    right: ${({ $showBurguerMobile }) =>
      !$showBurguerMobile ? "-100vw" : "0"};
    top: 0;
    width: 80%;
    height: 100vh;
    transition: 0.5s ease-in-out;
    overflow: hidden;
    .fondo-abm {
      width: 100vw;
      height: 100vh;
      position: fixed;
      right: 0;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: -1;
      display: ${({ $showBurguerMobile }) =>
        !$showBurguerMobile ? "none" : "0"};
    }
    .line-white {
      width: 100%;
      height: 2px;
      background: linear-gradient(
        to right,
        transparent 0%,
        var(--color-white) 20%,
        var(--color-white) 100%
      );
    }
    .iconBox {
      width: 30px;
      height: 25px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }
`;

export const TopMenu = styled.div`
  position: relative;
  width: 100%;
  min-height: 110px;
  display: flex;
  align-items: center;
  padding: 0px 10px;
  padding-top: 10px;

  .btn-close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: var(--color-primary);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    padding: 0;

    svg {
      width: 16px;
      height: 16px;
    }

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
    }

    &:active {
      transform: scale(0.95);
    }
  }

  .profile-link {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    cursor: pointer;
    padding: 8px 6px;
    border-radius: 12px;
    transition: background 0.2s ease;
    /* width: 100%; */
    /* max-width: calc(100% - 40px); */

    &:hover {
      background: rgba(255, 255, 255, 0.08);
    }
  }

  ${({ $isIos }) =>
    $isIos === true
      ? `padding-top: 50px;
         min-height: 160px;
         
         .btn-close {
           top: 50px;
         }
        `
      : ``};
`;

export const Image = styled.img`
  width: 60px;
  /* width: 50px; */
  /* min-width: 50px; */
  /* min-height: 50px; */
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.3);
  aspect-ratio: 1 / 1;
  flex-shrink: 0;
`;

export const TextTopMenu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  min-width: 0;

  .profile-name {
    font-size: 15px;
    font-weight: 600;
    color: var(--color-white);
    margin: 0;
    line-height: 1.3;
    word-break: break-word;
  }

  .profile-action {
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.75);
    margin-top: 3px;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`;

export const BodyMenu = styled.div`
  width: 100%;
  height: calc(100vh - 120px);
  margin: auto;
  overflow-y: auto;
  overflow-x: hidden;
  /* width */
  ::-webkit-scrollbar {
    width: 0;
  }
  .selected {
    background-color: #ff6600;
  }
  .ptur-socialSidebar-burguer {
    width: 100%;
    position: initial;
    padding-top: 20px;
  }
`;

export const ComboMenu = styled.div`
  ul {
    list-style: none;
    margin: auto;
    li {
      a {
        display: flex;
        align-items: center;
        text-decoration: none;
        gap: 10px;
        color: var(--color-white);
      }
      padding: 10px;
      padding-left: 40px;
    }
  }
  h1 {
    color: var(--color-white);
    font-size: 20px;
    margin-left: 20px;
  }

  &:first-child h1 {
    margin-top: 0;
  }
`;

export const FooterMenu = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: red;
  position: absolute;
  bottom: 0;
  left: 0;
`;
